import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Progression' },
    { value: 2, label: 'OTJ' },
  ],
});
